export const getters = {
  stage: state => state.stage,
  stages: state => state.stages
}

const GET_STAGES = 'stage/stages'

export const gettersTypes = {
  GET_STAGES
}
export default getters



// WEBPACK FOOTER //
// ./src/store/module/stage/getters.js